import Avatar from "antd/lib/avatar";
import Dropdown from "antd/lib/dropdown";
import Menu from "antd/lib/menu";
import * as React from "react";

import * as authService from "../../common/authService";
import "./index.css";

export default class UserMenu extends React.Component {
    handleMenuItemClick({ key }) {
        if (key === "logout") {
            authService.logout();
        }
    }
    renderMenu() {
        return (
            <Menu theme="dark" onClick={this.handleMenuItemClick}>
                <Menu.Item key="logout">{"Logout"}</Menu.Item>
            </Menu>
        );
    }
    render() {
        const currentUser = authService.getCurrentUser();
        return currentUser ? (
            <Dropdown overlay={this.renderMenu()} trigger={["click"]}>
                <div className="c-UserMenu">
                    <Avatar size="large" src={currentUser.photoURL} />
                </div>
            </Dropdown>
        ) : null;
    }
}



// WEBPACK FOOTER //
// ./src/components/UserMenu/index.js